import React, { Component } from 'react'
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import LowArrow from '../../../../../../../images/lowArrow.png'
import HighArrow from '../../../../../../../images/highArrow.png'
import _ from 'lodash'
import unserialize from 'locutus/php/var/unserialize'
import serialize from 'locutus/php/var/serialize'
import AvatarButton from './avn-button'
import { getDaysSinceWeighIn, hostDateToString, daysBetweenDateStrings } from '../../../util'
import {CustomTableRow} from './table-row'
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { saveHighLow } from "../../../../../../../api";

const HighLowSlider = withStyles({
  root: {
    color: '#06cb40',
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#dae3f1',
    border: '6px solid currentColor',
    marginTop: -13,
    marginLeft: -13,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: '#b7c1d6',
    height: 8,
    borderRadius: 4,
  },
})(Slider);

class HighLowTable extends Component {
  constructor(props) {
    super(props);
    const newState = this.getStateFromProps(this.props)

    this.state = {
      displayArrows: '',
      width: window.innerWidth,
      isLoading: false,
      ...newState
    }

    this.throttledResize = _.throttle(this.handleWindowSizeChange, 500);
  }

  componentDidMount() {
    window.addEventListener('resize', this.throttledResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResize);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(
        this.props.protein !== nextProps.protein || 
        this.props.carbs !== nextProps.carbs || 
        this.props.fat !== nextProps.fat || 
        this.props.highLowMask !== nextProps.highLowMask || 
        this.props.highLowFactor !== nextProps.highLowFactor || 
        this.props.highLowTweaks !== nextProps.highLowTweaks || 
        this.props.lastWeighInDate !== nextProps.lastWeighInDate ||
        this.props.macroHistory !== nextProps.macroHistory
      ) {
      const newState = this.getStateFromProps(nextProps)
      this.setState(newState)
    }
  }

  getStateFromProps = (props) => {
    let baseProteinList = Array(7).fill(Math.round(props.protein))
    let baseCarbsList = Array(7).fill(Math.round(props.carbs))
    let baseFatsList = Array(7).fill(Math.round(props.fat))
    let macroChangeDay = [0, 0, 0, 0, 0, 0, 0]
    let originalHighLowMask = props.highLowMask
    let currentHighLowMask = originalHighLowMask
    let originalHighLowFactor = (props.highLowFactor > 0) ? props.highLowFactor : 75
    let currentHighLowFactor = originalHighLowFactor
    let highLowTweaks = (props.highLowTweaks) ? unserialize(props.highLowTweaks) : []

    const recentWeighInUTCDate = new Date(props.lastWeighInDate)
    const recentWeighInDate = new Date(recentWeighInUTCDate.getUTCFullYear(), recentWeighInUTCDate.getUTCMonth(), recentWeighInUTCDate.getUTCDate())
    const daysSinceWeighIn = getDaysSinceWeighIn(props.lastWeighInDate)
    for (let mhi = props.macroHistory ? props.macroHistory.length : 0; mhi > 0;) {
      --mhi
      const endDate = new Date(props.macroHistory[mhi].end_date)
      const daysSinceRecentWeighInDate = Math.round((endDate.valueOf() - recentWeighInDate.valueOf()) / 86400000)
      const fillDays = daysSinceRecentWeighInDate < 7 ? daysSinceRecentWeighInDate : 7
      baseProteinList.fill(props.macroHistory[mhi].protein, 0, fillDays)
      baseCarbsList.fill(props.macroHistory[mhi].carbs, 0, fillDays)
      baseFatsList.fill(props.macroHistory[mhi].fat, 0, fillDays)
      if (fillDays < 7) {
        macroChangeDay[fillDays] = 1
      }
    }

    const lastWeighInDateString = hostDateToString(props.lastWeighInDate)
    if(props.settingsMacros) {
      props.settingsMacros.forEach((sm) => {
        const startDateOffset = daysBetweenDateStrings(lastWeighInDateString, hostDateToString(sm.date))
        if(startDateOffset >= 0 && startDateOffset < 7) {
          macroChangeDay[startDateOffset] = 1
          baseProteinList.fill(Math.round(sm.protein), startDateOffset, 7)
          baseCarbsList.fill(Math.round(sm.carbs), startDateOffset, 7)
          baseFatsList.fill(Math.round(sm.fat), startDateOffset, 7)
        }
      })
    }

    let macroAdjustments = Array(7).fill(null)
    if(props.macroAdjustments) {
      props.macroAdjustments.forEach((ma) => {
        const adjustmentDateOffset = daysBetweenDateStrings(lastWeighInDateString, hostDateToString(ma.adjustment_date))
        if(adjustmentDateOffset >= 0 && adjustmentDateOffset < 7) {
          macroAdjustments[adjustmentDateOffset] = ma
        }
      })
    }
    let finalHighLowDayCount = 7

    let rows = [];
    for(let hldi = 0; hldi < 7; hldi++) {
      if(macroAdjustments[hldi] !== null) {
        if(macroAdjustments[hldi].days_until_check_in !== null) {
          finalHighLowDayCount = hldi + macroAdjustments[hldi].days_until_check_in
          if(finalHighLowDayCount < 5 || finalHighLowDayCount > 7) {
            finalHighLowDayCount = 7
          }
        }
      }
      // Was causing time zone issue when going from Central Daylight to Central Standard (Nov 3rd 2019) - Rich
      // const weighInDate = new Date(recentWeighInDate.valueOf() + hldi * 86400000)

      const nextDay = new Date(recentWeighInDate)
      const weighInDate = new Date(nextDay.setDate(nextDay.getDate() + hldi))

      if(hldi in highLowTweaks) {
        currentHighLowMask = highLowTweaks[hldi][0]
        currentHighLowFactor = highLowTweaks[hldi][1]
      }
      rows.push({
        date: weighInDate.toDateString(),
        protein: baseProteinList[hldi],
        // updateRows will fill in type, fat, carbs, calories
        checked: (currentHighLowMask & (1 << hldi)) !== 0,
        disabled: hldi < daysSinceWeighIn,
      })
    }

    rows = this.updateRows(rows, baseProteinList, baseCarbsList, baseFatsList, macroChangeDay, macroAdjustments, originalHighLowMask, originalHighLowFactor, currentHighLowFactor, highLowTweaks, props.tdee)

    return {
      highLowFactor: currentHighLowFactor,
      baseProteinList: baseProteinList,
      baseCarbsList: baseCarbsList,
      baseFatsList: baseFatsList,
      macroChangeDay: macroChangeDay,
      macroAdjustments: macroAdjustments,
      finalHighLowDayCount: finalHighLowDayCount,
      rows: rows,
      allDaysAreDisabled: daysSinceWeighIn >= finalHighLowDayCount
    }
  }

  updateRows = (rows, baseProteinList, baseCarbsList, baseFatsList, macroChangeDay, macroAdjustments, originalHighLowMask, originalHighLowFactor, currentHighLowFactor, highLowTweaks, tdee) => {
    const cfRatio = 15

    let rowData = rows
    let totalCarbsBeforeDay = [0, 0, 0, 0, 0, 0, 0]

    let currentHighLowMask = 0
    for(let hldi = 0; hldi < 7; ++hldi)
      if(rowData[hldi].checked)
        currentHighLowMask = currentHighLowMask | (1 << hldi)
    let highLowMask = rowData[0].disabled ? originalHighLowMask : currentHighLowMask
    let highLowFactor = rowData[0].disabled ? originalHighLowFactor : currentHighLowFactor
    let totalBaseCarbs = 0
    let totalCarbsBeforeToday = 0
    let averageRemainingCarbs;
    let offsetMaxCarbIncrease;
    let offsetMaxCarbDecrease;
    let maxCarbIncrease = 0;
    let maxCarbDecrease = 0;
    let oldHighLowDayCount;
    let highLowDayCount = 7;

    for(let hldi = 0; hldi < 7; hldi++) {
      oldHighLowDayCount = highLowDayCount
      if(macroAdjustments[hldi] !== null) {
        if(macroAdjustments[hldi].days_until_check_in !== null) {
          highLowDayCount = hldi + macroAdjustments[hldi].days_until_check_in
          if(highLowDayCount < 5 || highLowDayCount > 7) {
            highLowDayCount = 7
          }
        }
      }
      const baseProtein = baseProteinList[hldi]
      const baseCarbs = baseCarbsList[hldi]
      const baseFats = baseFatsList[hldi]

      // Calculate MAX_CARB_INCREASE
      if(baseCarbs < 150) {
        maxCarbIncrease = baseCarbs * 0.700;
      } else if(baseCarbs >= 150 && baseCarbs < 750) {
        maxCarbIncrease = baseCarbs * Number(0.675-(Math.floor(baseCarbs/50)-3)*0.025).toFixed(3);
      } else {
        maxCarbIncrease = baseCarbs * 0.375;
      }

      // CALCULATE MAX_CARB_DECREASE
      if(baseCarbs > baseFats * cfRatio) {
        maxCarbDecrease = baseFats * cfRatio * 0.20
      } else {
        maxCarbDecrease = baseCarbs * 0.20
      }

      averageRemainingCarbs = baseCarbs
      // Update high/low macro buckets for following days on table
      if(hldi > 0) {
        if(hldi >= highLowDayCount) {
          rowData[hldi].type = 'lower'
          rowData[hldi].fat = baseFats
          rowData[hldi].carbs = baseCarbs
          rowData[hldi].calories = Math.round((baseProtein + baseCarbs) * 4 + baseFats * 9 )
          continue
        }
        totalCarbsBeforeToday = totalCarbsBeforeDay[hldi]
        averageRemainingCarbs = (totalBaseCarbs + baseCarbs * (highLowDayCount - hldi) - totalCarbsBeforeToday) / (highLowDayCount - hldi)
        if(hldi in highLowTweaks) {
          highLowMask = rowData[hldi].disabled ? highLowTweaks[hldi][0] : currentHighLowMask
          highLowFactor = rowData[hldi].disabled ? highLowTweaks[hldi][1] : currentHighLowFactor
        } else if (rowData[hldi - 1].disabled && !rowData[hldi].disabled && (highLowMask !== currentHighLowMask || highLowFactor !== currentHighLowFactor)) {
          highLowMask = currentHighLowMask
          highLowFactor = currentHighLowFactor
        } else if(!(macroChangeDay[hldi] || highLowDayCount !== oldHighLowDayCount)) {
          totalBaseCarbs += baseCarbs
          continue // This is required. It's like a break statement, but skips to the next interation of the for-loop
        }
      }
      totalBaseCarbs += baseCarbs

      offsetMaxCarbIncrease = maxCarbIncrease + baseCarbs - averageRemainingCarbs
      offsetMaxCarbDecrease = maxCarbDecrease - baseCarbs + averageRemainingCarbs
      // Calculate training and resting bits from high/low mask
      let trainingCount = 0
      let restingCount = 0
      for(let dayIndex = hldi; dayIndex < highLowDayCount; ++dayIndex) {
        (highLowMask & (1 << dayIndex)) ? trainingCount++ : restingCount++
      }

      if(offsetMaxCarbIncrease < 0)
        offsetMaxCarbIncrease = 0
        
      if(offsetMaxCarbDecrease < 0)
        offsetMaxCarbDecrease = 0

      let offsetRestingCarbDecrease
      let offsetTrainingCarbIncrease
      if(trainingCount === 0 || restingCount === 0) {
        offsetRestingCarbDecrease = 0
        offsetTrainingCarbIncrease = 0
      } else if(offsetMaxCarbIncrease * trainingCount > offsetMaxCarbDecrease * restingCount) {
        offsetRestingCarbDecrease = offsetMaxCarbDecrease * highLowFactor / 100
        offsetTrainingCarbIncrease = offsetRestingCarbDecrease * restingCount / trainingCount
      } else {
        offsetTrainingCarbIncrease = offsetMaxCarbIncrease * highLowFactor / 100
        offsetRestingCarbDecrease = offsetTrainingCarbIncrease * trainingCount / restingCount
      }

      // Calculate macro adjustments
      let restingFatDecrease = Math.round((offsetRestingCarbDecrease + baseCarbs - averageRemainingCarbs) / cfRatio)
      let trainingFatIncrease = Math.round((offsetTrainingCarbIncrease - baseCarbs + averageRemainingCarbs) / cfRatio)
      let restingCarbDecrease = Math.round(offsetRestingCarbDecrease + baseCarbs - averageRemainingCarbs)
      let trainingCarbIncrease = Math.round(offsetTrainingCarbIncrease - baseCarbs + averageRemainingCarbs)

      // Set table data
      for(let dayIndex = hldi; dayIndex < 7; ++dayIndex) {
        totalCarbsBeforeDay[dayIndex] = totalCarbsBeforeToday

        if(dayIndex >= highLowDayCount) {
          rowData[dayIndex].type = 'lower'
          rowData[dayIndex].fat = baseFats
          rowData[dayIndex].carbs = baseCarbs
          rowData[dayIndex].calories = Math.round((baseProtein + baseCarbs) * 4 + baseFats * 9 )
          totalCarbsBeforeToday += baseCarbs
        } else if(highLowMask & (1 << dayIndex)) { // Higher
          rowData[dayIndex].type = 'higher'
          rowData[dayIndex].fat = baseFats + trainingFatIncrease
          rowData[dayIndex].carbs = baseCarbs + trainingCarbIncrease
          rowData[dayIndex].calories = Math.round((baseProtein + baseCarbs + trainingCarbIncrease) * 4 + (baseFats + trainingFatIncrease) * 9)
          totalCarbsBeforeToday += baseCarbs + trainingCarbIncrease
        } else { // Lower
          rowData[dayIndex].type = 'lower'
          rowData[dayIndex].fat = baseFats - restingFatDecrease
          rowData[dayIndex].carbs = baseCarbs - restingCarbDecrease
          rowData[dayIndex].calories = Math.round((baseProtein + baseCarbs - restingCarbDecrease) * 4 + (baseFats - restingFatDecrease) * 9 )
          totalCarbsBeforeToday += baseCarbs - restingCarbDecrease
        }
      }
    }
    return rowData
  }

  updateHighLowValues = () => {
    let { rows, baseProteinList, baseCarbsList, baseFatsList, macroChangeDay, macroAdjustments, highLowFactor } = this.state;
    let originalHighLowMask = this.props.highLowMask
    let originalHighLowFactor = (this.props.highLowFactor > 0) ? this.props.highLowFactor : 75
    let highLowTweaks = (this.props.highLowTweaks) ? unserialize(this.props.highLowTweaks) : []
    rows = this.updateRows(rows, baseProteinList, baseCarbsList, baseFatsList, macroChangeDay, macroAdjustments, originalHighLowMask, originalHighLowFactor, highLowFactor, highLowTweaks, this.props.tdee)
    this.setState({rows: rows})
  }

  handleSlider = (e) => {
    this.setState({ highLowFactor: Number(e.target.value)}, this.updateHighLowValues)
  }

  handleSlider2 = (val) => {
    this.setState({ highLowFactor: Number(val)}, this.updateHighLowValues)
  }

  handleSave = () => {
    this.setState({isLoading: true})

    // Calculate mask
    let highLowMask = 0
    for(let hldi = 0; hldi < 7; ++hldi)
      if(this.state.rows[hldi].checked)
        highLowMask = highLowMask | (1 << hldi)
    let highLowFactor = this.state.highLowFactor;

    // Day since weigh in
    const daysSinceWeighIn = getDaysSinceWeighIn(this.props.lastWeighInDate);
    const highLowTweaks = (this.props.highLowTweaks) ? unserialize(this.props.highLowTweaks) : []

    if(daysSinceWeighIn !== 0) {
      highLowTweaks[daysSinceWeighIn] = [highLowMask, highLowFactor];
      highLowMask = this.props.highLowMask
      highLowFactor = this.props.highLowFactor
    }

    saveHighLow(this.props.userId, this.props.portalId, highLowFactor, highLowMask, serialize(highLowTweaks), this.props.lastWeighInDate)
      .then((res) => { 
        setTimeout(() => {
          this.setState({ isLoading: false });
          this.props.openSnackbar('Setting has been updated', false);
          this.props.setShowHighLowModal(false);
          this.props.loadPortalAccount();
        }, 1000);
      }).catch((err) => {
        setTimeout(() => {
          this.setState({ isLoading: false });
          this.props.openSnackbar('Setting failed to update', true)
        }, 1000);
      });

    // this.props.saveHighLow(this.props.userId, highLowFactor, highLowMask, serialize(highLowTweaks), this.props.lastWeighInDate)
    //   .then(() => {
    //     this.setState({
    //       isLoading: false,
    //     })
    //     this.props.openFeedback('High/Low settings have been saved', false)
    //   }).catch((err) => {
    //     this.setState({
    //       isLoading: false,
    //     })
    //     this.props.openFeedback('Failed to save High/Low settings', true)
    //   });
  }

  formatDay = (dayNum) => {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday',' Saturday'][dayNum]
  }

  formatMonth = (monthNum) => {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][monthNum]
  }

  getRowName = (disabled, checked) => {
    return (disabled) ? 'highlow-table-tr-disabled' : ((checked) ? 'highlow-table-tr-active' : 'highlow-table-tr')
  }

  renderData = () => {
    const tableRows = []
    const { rows: rowData } = this.state
    for(let i = 0; i < this.state.finalHighLowDayCount; i++) {
      const macroDate = new Date(rowData[i].date)
      macroDate.setDate(macroDate.getDate());
      tableRows.push(
        <TableRow key={i} className={this.getRowName(rowData[i].disabled, rowData[i].checked)} onClick={() => this.handleCellClick(i)}>
          <TableCell>{this.renderArrows(rowData[i].type)}</TableCell>
          {(this.state.width <= 550) ? (
            <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{String(macroDate.getMonth()+1 + '/' + macroDate.getDate())}</TableCell>
          ):(
            <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{String(this.formatDay(macroDate.getDay()) + ', ' + this.formatMonth(macroDate.getMonth()) + ' ' + macroDate.getDate())}</TableCell>
          )}
          <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{Number(rowData[i].protein).toFixed()}g</TableCell>
          <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{Number(rowData[i].carbs).toFixed()}g</TableCell>
          <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{Number(rowData[i].fat).toFixed()}g</TableCell>
          <TableCell id={rowData[i].disabled ? 'highlow-table-td-disabled' : 'highlow-table-td'}>{Number(rowData[i].calories).toFixed()}</TableCell>
        </TableRow>
      )
    }

    return tableRows;
  }

  renderRows = () => {
    const tableRows = []
    const { rows: rowData } = this.state
    for(let i = 0; i < this.state.finalHighLowDayCount; i++) {
      const macroDate = new Date(rowData[i].date)
      macroDate.setDate(macroDate.getDate());
      tableRows.push(
        <CustomTableRow
          disabled={rowData[i].disabled}
          key={i}
          date={(this.state.width <= 550) ? (
            String(macroDate.getMonth() + 1 + '/' + macroDate.getDate())
          ) : (
            String(this.formatDay(macroDate.getDay()) + ', ' + this.formatMonth(macroDate.getMonth()) + ' ' + macroDate.getDate())
          )}
          status={rowData[i].type}
          protein={Number(rowData[i].protein).toFixed()}
          carbs={Number(rowData[i].carbs).toFixed()}
          fat={Number(rowData[i].fat).toFixed()}
          calories={Number(rowData[i].calories).toFixed()}
          onClick={() => this.handleCellClick(i)}
        />
      )
    }

    return tableRows;
  }

  renderArrows = (status) => {
    let displayArrows = false
    for(let i = 0; i < this.state.rows.length; i++) {
      if(this.state.rows[i].type === 'higher')
        displayArrows = true
    }

    if(displayArrows) {
      return <img src={(status === 'lower') ? LowArrow : HighArrow} alt='arrow'/>
    }
  }

  handleCellClick = (rowNumber) => {
    const rowData = this.state.rows.slice()
    let displayArrows = false
    let rowIsChecked = rowData[rowNumber].checked;

    if(!rowData[rowNumber].disabled) {
      rowData[rowNumber].checked = (!rowIsChecked) ? true : false;
      rowData[rowNumber].type = (!rowIsChecked) ? 'higher' : 'lower';

      for(let i = 0; i < rowData.length; i++) {
        if (rowData[i].type === 'higher')
          displayArrows = true
      }

      this.setState({
        rows: rowData,
        displayArrows: (displayArrows) ? true : false
      }, this.updateHighLowValues())
    }
  }

  render() {
    // console.log(
    //   'reducer logs: ',
    //   this.props.userId,
    //   this.props.protein,
    //   this.props.carbs,
    //   this.props.tdee,
    //   this.props.fat,
    //   this.props.calories,
    //   this.props.highLowFactor,
    //   this.props.highLowMask,
    //   this.props.highLowTweaks,
    //   this.props.lastWeighInDate,
    //   this.props.macroHistory,
    //   this.props.settingsMacros,
    //   this.props.macroAdjustments,
    //   this.props.isLoading,
    // )
    return isNaN(this.state.rows[0].protein) ? '' : (
      <div className='highlow-table-container'>
        <h3 className='highlow-table-header'>Set which days you would like the user to have higher macro targets.</h3>
        {this.state.allDaysAreDisabled &&
         <p className='all-days-disabled-notice-p'><span>To use the  High / Low feature, you must check in again.</span></p>
        }
        <div className='highlow-table'>
          <div className='highlow-table-header' id='highlow-table-header'>
            <p className='date'>Date</p>
            <div className="toggle-container hidden">
              <p className='toggle'></p>
            </div>
            <p className='target'>{(this.state.width <= 550) ? 'P' : 'Protein' }</p>
            <p className='target'>{(this.state.width <= 550) ? 'C' : 'Carbs' }</p>
            <p className='target'>{(this.state.width <= 550) ? 'F' : 'Fat' }</p>
            <p className='target'>{(this.state.width <= 550) ? 'kCAL' : 'Calories' }</p>
          </div>
          <div>
            {this.renderRows()}
          </div>
        </div>
        <h3 id='highlow-slider-header'>Use this slider to increase macros on high days (this will decrease macros on low days)</h3>
        <div className='highlow-slider-container-tour'>
          <HighLowSlider 
            disabled={this.state.allDaysAreDisabled}
            min={0}
            max={100}
            value={this.state.highLowFactor}
            onChange={(e,val) => this.handleSlider2(val)}
            valueLabelDisplay='off'
            aria-label='highlow-slider'
          />
        </div>
        <div className='highlow-slider-row'>
          <p className='highlow-slider-label'>Less</p>
          <p className='highlow-slider-label'>More</p>
        </div>
        <AvatarButton className='highlow-table-save-button' onClick={this.handleSave} isLoading={this.state.isLoading} disabled={this.state.allDaysAreDisabled} message='Save days'/>
      </div>
    );
  }
}

// function mapStateToProps(state) {

  // return {
  //   userId: state.user.id,
  //   protein: state.user.protein,
  //   carbs: state.user.carbs,
  //   tdee: state.user.tdee,
  //   fat: state.user.fat,
  //   calories: state.user.calories,
  //   highLowFactor: state.user.high_low_factor,
  //   highLowMask: state.user.high_low_mask,
  //   highLowTweaks: state.user.high_low_tweaks,
  //   lastWeighInDate: state.user.lastWeighInDate,
  //   macroHistory: state.user.macroHistory,
  //   settingsMacros: state.user.settingsMacros,
  //   macroAdjustments: state.user.macroAdjustments,
  //   isLoading: state.user.isLoading,
  // }
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({saveHighLow, openFeedback}, dispatch)
// }

// export default connect(mapStateToProps, mapDispatchToProps)(HighLowTable)

export default HighLowTable;

